import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResult } from "@app/shared/model/apiresult";
import { ILookup } from "@app/shared/model/lookup";
import { environment as env } from '@environments/environment'
import { Guid } from "guid-typescript";
import { BehaviorSubject, of } from "rxjs";
import { tap } from "rxjs/operators";
import { IStudentHighSchool, IStudentHighSchoolScore, IStudentProspectGrid } from "../model/studenthighschool";

@Injectable({ providedIn: 'root' })

export class StudentHighSchoolService {

    constructor(private http: HttpClient) { }
    public showSpinner = new BehaviorSubject(false);
    get(studentId: Guid) {
        return this.http.get<ApiResult<IStudentProspectGrid[]>>(env.apiUrl + 'studenthighschool/'+studentId);
    }
    getById(studentHighSchoolId: Guid) {
        return this.http.get<ApiResult<IStudentHighSchool>>(env.apiUrl + 'studenthighschool/GetById/' + studentHighSchoolId);
    }
    getHighSchoolScore(studentId: Guid) {
        return this.http.get<ApiResult<IStudentHighSchoolScore>>(env.apiUrl + 'studenthighschool/GetHighSchoolScore/'+studentId);
    }
    getCurrentHighSchool(studentId: Guid) {
        return this.http.get<ApiResult<IStudentHighSchool>>(env.apiUrl + 'studenthighschool/GetCurrentHighSchool/'+studentId);
    }
    post(studentHighSchool: IStudentHighSchool) {
        return this.http.post<ApiResult<Guid>>(env.apiUrl + 'studenthighschool', studentHighSchool);
    }
    put(studentHighSchool: IStudentHighSchool) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'studenthighschool', studentHighSchool);
    }
    delete(studentHighSchoolId:Guid) {
        return this.http.delete<ApiResult<any>>(env.apiUrl + 'studenthighschool/' + studentHighSchoolId);
    }
    instituteSearch(value:any) {
        
      //return  this.http.get<ApiResult<ILookup[]>>(env.apiUrl + 'Lookup/GetInstitutionByValue/' + value);
    //   return this.opts.length ?
    //         of(this.opts) :
    //         this.http.get(env.apiUrl + 'Lookup/GetInstitutionByValue/' + value).pipe(tap(data => this.opts = data))

            return this.http.get<ApiResult<ILookup[]>>(env.apiUrl + 'Lookup/GetInstitutionByValue/' + value).pipe(
                tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
            );
    }
}
